// Light-mode industrial-instrumentation theme tokens for the Seed Fridge
// Inventory page. Colors, type, spacing, and motion are committed here so the
// page has a distinct, recognizable aesthetic instead of inheriting the CMS
// default styles.

const theme = {
  color: {
    // Near-white surface with a hint of cool grey so it doesn't feel clinical.
    bg: '#F7F8FA',
    bgRaised: '#FFFFFF',
    bgOverlay: 'rgba(255, 255, 255, 0.72)',

    border: 'rgba(15, 23, 42, 0.10)',
    borderStrong: 'rgba(15, 23, 42, 0.18)',
    borderInset: 'rgba(255, 255, 255, 0.85)',

    // Single dominant accent — used for fresh state, primary button, focus
    // rings. Slightly deeper green than the dark-mode version so it holds
    // contrast on a white surface.
    accent: '#10B981',
    accentDim: 'rgba(16, 185, 129, 0.12)',
    accentGlow: 'rgba(16, 185, 129, 0.25)',
    // Text on top of the accent-colored primary button.
    accentFg: '#FFFFFF',

    // Sharp accents — reserved for per-bottle pills.
    warn: '#D97706',
    danger: '#DC2626',

    // Text ramp, dark-to-light.
    text0: '#0F172A',
    text1: '#1F2937',
    text2: '#374151',
    text3: '#6B7280',
    text4: '#9CA3AF',
    text5: '#D1D5DB',
    text6: '#E5E7EB',
    text7: '#F3F4F6',
  },

  font: {
    display: '"IBM Plex Sans", "Inter", system-ui, sans-serif',
    body: '"IBM Plex Sans", "Inter", system-ui, sans-serif',
    mono: '"JetBrains Mono", "IBM Plex Mono", "SF Mono", Menlo, monospace',
  },

  radius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
  },

  // Rem-based spacing scale.
  space: {
    xxs: '0.25rem',
    xs: '0.5rem',
    sm: '0.75rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },

  shadow: {
    card: '0 1px 2px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.06)',
    modal: '0 24px 60px rgba(15, 23, 42, 0.18)',
  },

  motion: {
    quick: '120ms ease-out',
    base: '220ms cubic-bezier(0.22, 1, 0.36, 1)',
    stagger: 30, // ms between slot reveals
  },
};

export default theme;
